export function createBasicStorage() {
    localStorage.hostSave = process.env.VUE_APP_BASE_URL;
    window.host = process.env.VUE_APP_BASE_URL;

    console.log(localStorage.hostSave);
}